export const handleAddToList = (product, setProducts) => {
  if (Object.keys(product).length > 0) {
    const products = JSON.parse(localStorage.getItem("products")) || [];
    products.push({
      ...product,
      quantity: 1,
    });

    setProducts(products);
    localStorage.setItem("products", JSON.stringify(products));
  }
};

export const checkProductInStorage = (product, products) => {
  if (products && products.length > 0) {
    const isProduct = products.filter((item) => {
      const { name, id } = product;
      const dataId = `${item.id}-${item.name}`;
      const itemId = `${id}-${name}`;

      return dataId === itemId;
    });

    if (isProduct && isProduct.length > 0) {
      return true;
    } else {
      return false;
    }
  }
};

export const isProductExpired = (product) => {
  if (product && Object.keys(product).length > 0) {
    const { valid_to } = product;
    if (valid_to) {
      const now = new Date().getTime();
      const validTill = new Date(valid_to).getTime();
      

      // Ensure 'validTill' is a valid date
      if (isNaN(validTill)) {
        throw new Error(`Invalid date format in 'valid_to': ${valid_to}`);
      }

      // Compare the timestamps
      return now >= validTill;
    }
  }
  return false;
};
